import React from 'react';

import OtpInput from 'react-otp-input';

import { cn } from '../../lib/utils';

export default function AuthCodeInput({ code, codeLength, disabled, errorMessageId, hasError, onChange, showInlineError = false }) {
  return (
    <div className={cn('flex w-full flex-col', showInlineError && 'gap-2')}>
      {showInlineError ? (
        <div className="flex w-full items-start justify-end text-[13px] leading-5 text-red-500">
          <p id={errorMessageId}>Invalid code</p>
        </div>
      ) : null}
      <OtpInput
        value={code}
        onChange={onChange}
        numInputs={codeLength}
        inputType="tel"
        shouldAutoFocus
        skipDefaultStyles
        placeholder={'0'.repeat(codeLength)}
        containerStyle="flex w-full items-center justify-between gap-2"
        renderInput={(inputProps) => (
          <input
            {...inputProps}
            aria-describedby={hasError ? errorMessageId : undefined}
            aria-invalid={hasError}
            autoComplete="one-time-code"
            className={cn(
              'h-12 min-w-0 flex-1 rounded-lg border sm:border-[0.5px] border-gray-300 bg-gray-100 px-4 py-3 text-center text-[15px] leading-5 font-normal text-black transition-colors outline-none placeholder:text-black/10 hover:border-gray-400 hover:bg-[#eceef1] focus:border-black focus:bg-white disabled:cursor-not-allowed disabled:opacity-70',
              hasError && 'border-red-500 bg-red-50 hover:border-red-500 hover:bg-red-50 focus:border-red-500 focus:bg-red-50',
            )}
            data-app-region="none"
            disabled={disabled}
            pattern="[0-9]*"
          />
        )}
      />
    </div>
  );
}
